export const parsePassengers = (passengers) => {
  const pax_i = passengers?.reduce((acc, pax) => acc + pax.pax_i, 0);
  const pax_m = passengers?.reduce((acc, pax) => acc + pax.pax_m, 0);
  const pax_z = passengers?.reduce((acc, pax) => acc + pax.pax_z, 0);

  return { pax_i, pax_m, pax_z };
};
